/* core-quantity-breaks: leagă pragurile (radio) de selectorul de cantitate Dawn (#Quantity-<section>). */
if (!customElements.get('core-quantity-breaks')) {
  customElements.define(
    'core-quantity-breaks',
    class CoreQuantityBreaks extends HTMLElement {
      connectedCallback() {
        this.onPick = this.onPick.bind(this);
        this.onQuantity = this.onQuantity.bind(this);
        this.addEventListener('change', this.onPick);
        document.addEventListener('input', this.onQuantity);
        document.addEventListener('change', this.onQuantity);

        if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
          // Dawn readuce cantitatea la minim când se schimbă varianta (fără eveniment change).
          this.unsubQuantity = subscribe(PUB_SUB_EVENTS.quantityUpdate, () => this.sync());
          this.unsubVariant = subscribe(PUB_SUB_EVENTS.variantChange, ({ data }) => {
            if (data?.sectionId !== this.dataset.section || !data.html) return;
            const fresh = data.html.getElementById(this.id);
            if (fresh) this.innerHTML = fresh.innerHTML;
            this.sync();
          });
        }

        this.sync();
      }

      disconnectedCallback() {
        this.removeEventListener('change', this.onPick);
        document.removeEventListener('input', this.onQuantity);
        document.removeEventListener('change', this.onQuantity);
        this.unsubQuantity?.();
        this.unsubVariant?.();
      }

      get quantityInput() {
        return document.getElementById(`Quantity-${this.dataset.section}`);
      }

      get radios() {
        return Array.from(this.querySelectorAll('.core-qb__input'));
      }

      onPick(event) {
        const radio = event.target;
        const input = this.quantityInput;
        if (!radio.classList?.contains('core-qb__input') || !radio.checked || !input) return;
        event.stopPropagation();

        let value = parseInt(radio.value, 10);
        const max = parseInt(input.max, 10);
        if (max && value > max) value = max;
        if (String(value) === input.value) return;

        input.value = value;
        input.dispatchEvent(new Event('change', { bubbles: true }));
      }

      onQuantity(event) {
        if (event.target === this.quantityInput) this.sync();
      }

      // Bifează pragul cel mai mare care nu depășește cantitatea (ultimul prag acoperă și cantitățile mai mari).
      sync() {
        const input = this.quantityInput;
        if (!input) return;
        const qty = parseInt(input.value, 10) || 0;
        let match = null;
        for (const radio of this.radios) {
          if (parseInt(radio.value, 10) <= qty && (!match || parseInt(radio.value, 10) > parseInt(match.value, 10))) {
            match = radio;
          }
        }
        for (const radio of this.radios) radio.checked = radio === match;
      }
    }
  );
}
